// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Removed unused Saga, Added Comments'
// Modified Date : 23-08-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	createJournalEntryFailure,
	createJournalEntryResponseChanged,
	createJournalEntrySuccess,
	getParticularAccountDetailsFailure,
	getParticularAccountDetailsResponseChanged,
	getParticularAccountDetailsSuccess,
	getVoucherCountFailure,
	getVoucherCountSuccess,
	getVoucherDetailsResponseChanged,
	updateJournalEntryFailure,
	updateJournalEntryResponseChanged,
	updateJournalEntrySuccess,
} from './journal-transaction.action';
import JournalTransactionTypes from './journal-transaction.types';
import {
	getCreateJournalEntryService,
	getJournalTransactionVoucherCountDetailsService,
	getParticularAccountDetailsService,
	getUpdateJournalEntryService,
} from './journal-transaction.service';

/** ***************** FETCH VOUCHER COUNT START *********************** */
export function* getVoucherCountDetails({ payload }: any) {
	try {
		const key = 'GetJournalTransactionVoucherCountKey';
		const {
			infogCmpID,
			branchID,
			toBranchID,
			entryDate,
			databaseName,
			accountID,
			transactionType,
		} = payload;
		const jsonData = {
			InfogCmpID: infogCmpID,
			BranchID: branchID,
			ToBranchID: toBranchID,
			EntryDate: entryDate,
			DatabaseName: databaseName,
			AccountID: accountID,
			TransactionType: transactionType,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(
			getJournalTransactionVoucherCountDetailsService,
			encodeData,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getVoucherCountFailure(responseData.data));
		} else {
			yield put(getVoucherCountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getVoucherCountFailure(error));
	}
}

export function* resetVoucherCountDetailsResponse() {
	yield put(getVoucherDetailsResponseChanged());
}

export function* onFetchVoucherCountDetails() {
	yield takeLatest(
		JournalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_START,
		getVoucherCountDetails,
	);
}

export function* onFetchVoucherCountResponseReset() {
	yield takeLatest(
		JournalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_RESET,
		resetVoucherCountDetailsResponse,
	);
}
/** ***************** FETCH VOUCHER COUNT END *********************** */

/** ***************** GET PARTICULAR ACCOUNT DETAILS START *********************** */

export function* getParticularAccountDetails({ payload }: any) {
	try {
		const key = 'GetParticularAccountDetailsKey';
		const { databaseName, accountID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			AccountID: accountID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getParticularAccountDetailsService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularAccountDetailsFailure(responseData.data));
		} else {
			yield put(getParticularAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularAccountDetailsFailure(error));
	}
}

export function* resetParticularAccountDetailsResponse() {
	yield put(getParticularAccountDetailsResponseChanged());
}

export function* onFetchParticularAccountDetails() {
	yield takeLatest(
		JournalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_START,
		getParticularAccountDetails,
	);
}

export function* onFetchParticularAccountDetailsResponseReset() {
	yield takeLatest(
		JournalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetParticularAccountDetailsResponse,
	);
}
/** ***************** GET PARTICULAR ACCOUNT DETAILS END *********************** */

/** ***************** CREATE JOURNAL ENTRY START *********************** */
export function* createJournalEntry({ payload }: any) {
	try {
		const key = 'CreateJournalEntryKey';
		const {
			accountID,
			branchID,
			entryDate,
			voucherDate,
			voucherNo,
			createdBy,
			transactionType,
			infogCompanyID,
			totalAmount,
			transcationArr,
			createdFor,
			isLoanCollection,
			modifiedBy,
			userName,
			databaseName,
		} = payload;
		const jsonData = {
			AccountID: accountID,
			BranchID: branchID,
			EntryDate: entryDate,
			VoucherDate: voucherDate,
			VoucherNo: voucherNo,
			CreatedBy: createdBy,
			TransactionType: transactionType,
			InfogCompanyID: infogCompanyID,
			TotalAmount: totalAmount,
			TranscationArr: transcationArr,
			CreatedFor: createdFor,
			IsLoanCollection: isLoanCollection,
			ModifiedBy: modifiedBy,
			UserName: userName,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(getCreateJournalEntryService, encodeData);

		if (response?.data?.statusCode === '100') {
			yield put(createJournalEntryFailure(response.data));
		} else {
			yield put(createJournalEntrySuccess(response.data));
		}
	} catch (error) {
		yield put(createJournalEntryFailure(error));
	}
}

export function* resetCreateJournalEntryResponse() {
	yield put(createJournalEntryResponseChanged());
}

export function* onCreateJournalEntry() {
	yield takeLatest(JournalTransactionTypes.CREATE_JOURNAL_ENTRY_START, createJournalEntry);
}

export function* onCreateJournalEntryResponseReset() {
	yield takeLatest(
		JournalTransactionTypes.CREATE_JOURNAL_ENTRY_RESPONSE_RESET,
		resetCreateJournalEntryResponse,
	);
}
/** ***************** CREATE JOURNAL ENTRY END *********************** */

/** ***************** UPDATE JOURNAL ENTRY START *********************** */
export function* updateJournalEntry({ payload }: any) {
	try {
		const key = 'UpdateJournalTransactionKey';
		const {
			infogCompanyID,
			accountID,
			entryDate,
			transactionType,
			transactionID,
			totalAmount,
			transcationArr,
			createdBy,
			createdFor,
			isLoanCollection,
			branchID,
			databaseName,
			modifiedBy,
			userName,
		} = payload;
		const jsonData = {
			InfogCompanyID: infogCompanyID,
			AccountID: accountID,
			EntryDate: entryDate,
			TransactionType: transactionType,
			TransactionID: transactionID,
			TotalAmount: totalAmount,
			TranscationArr: transcationArr,
			CreatedBy: createdBy,
			CreatedFor: createdFor,
			IsLoanCollection: isLoanCollection,
			BranchID: branchID,
			DatabaseName: databaseName,
			ModifiedBy: modifiedBy,
			UserName: userName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(getUpdateJournalEntryService, encodeData);

		if (response?.data?.statusCode === '100') {
			yield put(updateJournalEntryFailure(response.data));
		} else {
			yield put(updateJournalEntrySuccess(response.data));
		}
	} catch (error) {
		yield put(updateJournalEntryFailure(error));
	}
}

export function* resetUpdateJournalEntryResponse() {
	yield put(updateJournalEntryResponseChanged());
}

export function* onUpdateJournalEntry() {
	yield takeLatest(JournalTransactionTypes.UPDATE_JOURNAL_ENTRY_START, updateJournalEntry);
}

export function* onUpdateJournalEntryResponseReset() {
	yield takeLatest(
		JournalTransactionTypes.UPDATE_JOURNAL_ENTRY_RESPONSE_RESET,
		resetUpdateJournalEntryResponse,
	);
}
/** ***************** UPDATE JOURNAL ENTRY END *********************** */

export function* journalTransactionDetailsSaga() {
	yield all([
		call(onFetchVoucherCountResponseReset),
		call(onFetchVoucherCountDetails),
		call(onFetchParticularAccountDetails),
		call(onFetchParticularAccountDetailsResponseReset),
		call(onCreateJournalEntry),
		call(onCreateJournalEntryResponseReset),
		call(onUpdateJournalEntryResponseReset),
		call(onUpdateJournalEntry),
	]);
}
